<template>
  <div class="noMatchList">
    <div class="header">
      <span
        class="header-title"
        @click="upDownFc"
      >查看更多
        <span v-if='updownFlag'>
          <van-icon name="arrow-up" />
        </span>
        <span v-else>
          <van-icon name="arrow-down" />
        </span>

      </span>
    </div>
    <div
      class="list"
      v-show='updownFlag'
    >
      <product-item
        ref="productListRef"
        :key="index"
        v-for="(item, index) in productList"
        :productItemData="item"
      >
      </product-item>
    </div>
  </div>
</template>
<script>
import ProductItem from '@/views/pages/publicPage/loanSupermarket/components/ProductItem.vue';

export default {
  name: 'noMatchLists',
  data() {
    return {
      updownFlag: false,
      productList: [],
    };
  },
  props: ['noMatchList'],
  watch: {
    noMatchList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.productList = val;
      },
    },
  },
  methods: {
    upDownFc() {
      this.updownFlag = !this.updownFlag;
    },
  },
  components: {
    ProductItem,
  },
};
</script>
<style lang="scss" scoped>
.header-title {
  display: block;
  font-size: 14px;
  color: #b4b6b9;
  font-weight: bold;

  padding: 24px 0 12px 0;
}
</style>
